import { initializeApp, getApps, getApp, type FirebaseApp } from 'firebase/app';
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getFunctions, httpsCallable } from 'firebase/functions';

const firebaseConfig = {
  apiKey: 'AIzaSyCDNYvI5t5za07WCc5R9o4eeVC7hx84M0A',
  authDomain: 'arimage-f84ba.firebaseapp.com',
  projectId: 'arimage-f84ba',
  storageBucket: 'arimage-f84ba.firebasestorage.app',
  messagingSenderId: '85337517437',
  appId: '1:85337517437:web:76c7507200d0b00d91b014',
  measurementId: 'G-F86SC4M0XC',
};

let app: FirebaseApp | undefined;
let auth: any = null;
let db: any = null;
let storage: any = null;
let messaging: any = null;
let analytics: any = null;
let functions: any = null;

try {
  app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  storage = getStorage(app);
  functions = typeof window !== 'undefined' ? getFunctions(app) : null;
  messaging = typeof window !== 'undefined' ? getMessaging(app) : null;

  if (typeof window !== 'undefined') {
    isSupported().then((supported) => {
      if (supported && app) {
        analytics = getAnalytics(app);
      }
    });
  }
} catch (err) {
  console.warn('Firebase not initialized:', err);
}

export { auth, db, storage, messaging, analytics, functions };
export const callFunction = (name: string) => {
  if (!functions) throw new Error('Firebase Functions not initialized');
  return httpsCallable(functions, name);
};

export const requestNotificationPermission = async () => {
  if (!messaging) return null;
  try {
    const token = await getToken(messaging, {
      vapidKey: process.env.NEXT_PUBLIC_FIREBASE_VAPID_KEY,
    });
    return token;
  } catch (err) {
    console.error('Notification permission denied', err);
    return null;
  }
};

export const onMessageListener = () => {
  if (!messaging) return;
  return new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
};

export { signInWithPhoneNumber, RecaptchaVerifier };
export default app;
